export default {
	viewportSize: '',
}
